import React from "react";
import { ManualItemForSelector } from "store/manual/manuals/types.d";
import styled from "styled-components";
import { color } from "components/mixins";
import editCancelIcon from "images/icons/editmode_cancel.svg";

interface Props {
  manual: ManualItemForSelector;
  updateManualTitle: (data: { order: number; new_name: string }) => void;
  removeHookedItem: (data: { manual: ManualItemForSelector }) => void;
}

function ManualsEditableItem(props: Props) {
  const { manual, updateManualTitle, removeHookedItem } = props;

  const handleChange = (data: {
    e: React.ChangeEvent<HTMLInputElement>;
    order: number;
  }) => {
    const { e, order } = data;
    updateManualTitle({ order: order, new_name: e.target.value });
  };

  return (
    <ManualsItemTitleEditable>
      <ManualsItemContent>
        <input
          type="text"
          value={manual.name}
          onChange={e => handleChange({ e: e, order: manual.order })}
        />
        <img
          src={editCancelIcon}
          alt="Remove"
          style={{ cursor: "pointer" }}
          onClick={() => {
            removeHookedItem({ manual });
          }}
        />
      </ManualsItemContent>
    </ManualsItemTitleEditable>
  );
}

export default ManualsEditableItem;

const ManualsItemTitleEditable = styled.li`
  display: block;
  padding: 22px 22px 22px 55px;
  border-bottom: 1px solid ${color.list_border};
`;

const ManualsItemContent = styled.dl`
  color: ${color.black};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
